module.exports = __webpack_public_path__ + "img/IS530990-2149.8d4b4142.png";